// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"eb3ae553","845":"43df4d5c","972":"355bd346"}[chunkId] + ".chunk.css";
};